// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InlineForm-module__Container__wKXQG {
    display: flex;
    flex-direction: column;
    gap: var(--ds-s);
    width: 100%;
}

.InlineForm-module__InlineEditorContainer__ZSy22 {
    display: flex;
    flex-direction: row;
    gap: var(--ds-s);
    align-items: flex-start;
    width: 100%;
}

.InlineForm-module__LabelContainer__LuyYf {
    display: flex;
    gap: var(--ds-xs);
    align-items: center;
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features -- according to MDN
     max-content has full Mozilla support since Firefox 66
     https://developer.mozilla.org/en-US/docs/Web/CSS/max-content#browser_compatibility */
    width: max-content;
    max-width: 100%;
}

.InlineForm-module__LabelDisabled__i2zs6 {
    color: var(--ds-input-disabled-label-color);
}

.InlineForm-module__DescriptionDisabled__RbGgS {
    color: var(--ds-input-disabled-description-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `InlineForm-module__Container__wKXQG`,
	"InlineEditorContainer": `InlineForm-module__InlineEditorContainer__ZSy22`,
	"LabelContainer": `InlineForm-module__LabelContainer__LuyYf`,
	"LabelDisabled": `InlineForm-module__LabelDisabled__i2zs6`,
	"DescriptionDisabled": `InlineForm-module__DescriptionDisabled__RbGgS`
};
export default ___CSS_LOADER_EXPORT___;
